
const emailField = {
  id: 'emailField',
  type: 'email',
  placeholder: 'Your email address'
};

const nameField = {
  id: 'nameField',
  type: 'text',
  placeholder: 'Your name'
};

const subjectField = {
  id: 'subjectField',
  type: 'text',
  placeholder: 'Subject'
};

const messageBodyField = {
  id: 'messageField',
  type: 'textarea',
  placeholder: 'Write your message here'
};

const handlerFor = {
  [emailField.id]: {
    default: {
      helpVisibility: 'visible',
      helpMsg: 'Email - required ^'
    },

    isValid: (email, { checkMinChars = true } = {}) => {
      const minCharsB4Trigger = 5;

      if (checkMinChars) if (email.length < minCharsB4Trigger) return true;

      if (email.match(/@/)) return true;

      return false;
    },

    failedValidationMessage: 'Invalid email address, no \'@\' character ^'
  },

  [nameField.id]: {
    default: { helpVisibility: 'hidden', helpMsg: 'Placeholder' },
    isValid: () => true,
    // isValid: (name) => (name && name.length > 0 ? true : false),
    failedValidationMessage: 'Name must not be blank ^'
  },

  [subjectField.id]: {
    default: { helpVisibility: 'hidden', helpMsg: 'Placeholder' },
    isValid: () => true,
    // isValid: (subject) => (subject && subject.length > 0 ? true : false),
    failedValidationMessage: 'Subject must not be blank ^'
  },

  [messageBodyField.id]: {
    default: { helpVisibility: 'visible', helpMsg: 'Message body - required ^' },
    isValid: (messageBody) => {
      return (messageBody && messageBody.length > 0 ? true : false);
    },
    failedValidationMessage: 'Message body must not be blank ^'
  }
};

const alertDismissState = {
  alert: {
    msg: null,
    visible: false
  }
};

const getInitialState = () => ({
  alert: {
    msg: null,
    visible: false
  },

  [emailField.id]: {
    value: '',
    validation: null, // for Bootstrap automatic input field decorator
    isValid: false,
    helpMsg: handlerFor[emailField.id].default.helpMsg,
    helpVisibility: handlerFor[emailField.id].default.helpVisibility
  },

  [nameField.id]: {
    value: '',
    isValid: true,
    validation: null,
    helpMsg: handlerFor[nameField.id].default.helpMsg,
    helpVisibility: handlerFor[nameField.id].default.helpVisibility
  },

  [subjectField.id]: {
    value: '',
    isValid: true,
    validation: null,
    helpMsg: handlerFor[subjectField.id].default.helpMsg,
    helpVisibility: handlerFor[subjectField.id].default.helpVisibility
  },

  [messageBodyField.id]: {
    value: '',
    isValid: false,
    validation: null,
    helpMsg: handlerFor[messageBodyField.id].default.helpMsg,
    helpVisibility: handlerFor[messageBodyField.id].default.helpVisibility
  }
});

export {
  emailField,
  nameField,
  subjectField,
  messageBodyField,

  handlerFor,

  alertDismissState,

  getInitialState
};



// WEBPACK FOOTER //
// ./src/components/contact/contact.js